import baseApi from './baseApi'

export const uploadsApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        uploadImage: build.mutation({
            query: (formData) => ({
                url: 'uploads/image',
                method: 'POST',
                body: formData,
            }),
        }),
    }),
    overrideExisting: false,
})

export const {useUploadImageMutation} = uploadsApi
